import { texts } from "../data/langs";
import feather from "feather-icons";
import "../App.css";

export const Services = () => {
  const features = texts[texts.active].services.features;

  return (
    <section className="limiter" id="Serviços">
      <div className="gradTxt">{texts[texts.active].services.div}</div>

      <div className="GAP-20" />

      <h1 className="limiter2">{texts[texts.active].services.h1}</h1>
      <h3 className="limiter2">{texts[texts.active].services.h3}</h3>

      <div className="GAP-20" />
      <div className="GAP-20" />

      <div className="auto-columns smart-center">
        {features.map((i) => {
          return (
            <>
              <div className="box_features col-max3">
                <div
                  className="box_icon"
                  dangerouslySetInnerHTML={{
                    __html: feather.icons[i.icon].toSvg({
                      class: "foo bar",
                      "stroke-width": 1,
                      stroke: "aqua",
                    }),
                  }}
                />
                <div className="GAP-H20" />

                <span className="box_title">{i.title}</span>
                <span className="box_text">{i.text}</span>
              </div>
            </>
          );
        })}
      </div>
    </section>
  );
};
